import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  #http = inject(HttpClient);

  readonly BASE_URL = '/version';

  getVersion() {
    return this.#http.get(this.BASE_URL, { responseType: 'text' });
  }
}
